// removed by extract-text-webpack-plugin
module.exports = {"layoutWrapperMain":"styles__layoutWrapperMain__2zzoQ","root":"styles__root__3utvH","container":"styles__container__klNEO"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CongratPoolPage/styles.css
// module id = 2490
// module chunks = 0